import React from "react";

const FeaturedImage = props => {
  const { data, fallbackImage, size, className = "" } = props;
  // Set featured image url and alt text
  let _featuredImage, _featuredImageAlt;

  // Default settings to ensure images are not enormous
  let _width = "1200",
    _height = "",
    _fit = "";

  if (size !== undefined && typeof size === "object") {
    if (size.width) {
      _width = size.width;
    } else {
      _width = "";
    }
    if (size.height) {
      _height = size.height;
    } else {
      _height = "";
    }
    if (size.fit) {
      _fit = size.fit;
    } else {
      _fit = "fill";
    }
  }

  if (
    data.featuredImageref &&
    data.featuredImageref.file &&
    data.featuredImageref.file.url
  ) {
    _featuredImage = data.featuredImageref.file.url;
    if (data.featuredImageref.title) {
      _featuredImageAlt = data.featuredImageref.title;
    } else {
      _featuredImageAlt = data.subjectTitle;
    }
  } else {
    _featuredImage = fallbackImage;
    _featuredImageAlt = data.subjectTitle;
  }

  return (
    <img
      src={`${_featuredImage}?w=${_width}&h=${_height}&fit=${_fit}`}
      className={`news__featured-image ${className}`}
      alt={_featuredImageAlt}
    />
  );
};
export default FeaturedImage;
